import React from "react";
import { errorImage } from "../../assets/layout";
import { useUtils } from "../../customHooks/useUtils";

function CardError({ message, className }: { message?: string, className?: string }) {
  const { FEEDBACK_MESSAGES } = useUtils();
  return (
    <div className="flex flex-col  justify-center items-center h-full w-full">
      <img
        src={errorImage}
        alt="unable to fetch data"
        className={`max-h-[130px] ${className}`}
      />
      <span className="font-semibold">{message || FEEDBACK_MESSAGES.ERROR}</span>
    </div>
  );
}

export default CardError;
